import eventTypes from "@/events/event-types";
import { Circ, Power3, TimelineLite, TweenLite } from "gsap";
var Top = /** @class */ (function () {
    function Top() {
        console.log("[create] Top");
    }
    Top.prototype.setup = function () {
        var topCoverElem = document.querySelector(".top-cover");
        if (topCoverElem) {
            this._topCoverElem = topCoverElem;
        }
        var topCoverLogoElem = document.querySelector(".top-cover__logo");
        if (topCoverLogoElem) {
            this._topCoverLogoElem = topCoverLogoElem;
        }
        var topCoverTitleElem = document.querySelector(".top-cover__title");
        if (topCoverTitleElem) {
            this._topCoverTitleElem = topCoverTitleElem;
        }
        var topCoverNextElem = document.querySelector(".top-cover__next");
        if (topCoverNextElem) {
            this._topCoverNextElem = topCoverNextElem;
        }
        var bgElem = document.getElementById("bg");
        if (bgElem) {
            this._bgElem = bgElem;
        }
        var tl = new TimelineLite();
        tl.fromTo(this._bgElem, 0.6, { x: "100%" }, { x: "0%", ease: Circ.easeInOut }, 0.8).fromTo(this._topCoverNextElem, 0.4, { y: "-20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: Circ.easeInOut }, 1.3);
        this._setNativeEvents();
        this._reset();
    };
    Top.prototype.teardown = function () {
        this._clearNativeEvents();
    };
    Top.prototype._setNativeEvents = function () {
        var _this = this;
        this._onResize = function () { return _this._reset(); };
        this._onLoad = function () {
            window.removeEventListener(eventTypes.LOAD, _this._onLoad);
            var tl = new TimelineLite();
            tl.fromTo(_this._topCoverLogoElem, 1, {
                x: "10%",
                autoAlpha: 0,
            }, {
                x: "0%",
                autoAlpha: 1,
                ease: Power3.easeOut,
            }).fromTo(_this._topCoverTitleElem, 0.8, {
                x: "5%",
                autoAlpha: 0,
            }, {
                x: "0%",
                autoAlpha: 1,
                ease: Power3.easeOut,
            }, "-=.6");
        };
        window.addEventListener(eventTypes.RESIZE, this._onResize);
        window.addEventListener(eventTypes.LOAD, this._onLoad);
    };
    Top.prototype._clearNativeEvents = function () {
        window.removeEventListener(eventTypes.RESIZE, this._onResize);
    };
    Top.prototype._reset = function () {
        TweenLite.set([this._topCoverElem], {
            height: document.documentElement.clientHeight,
        });
    };
    return Top;
}());
export default Top;
